import React from "react";
import { useTranslation } from "react-i18next";
import HomeIcon from "@mui/icons-material/Home";
import RefreshIcon from "@mui/icons-material/Refresh";
import SettingsIcon from "@mui/icons-material/Settings";
import { LiveTrainingClubLogo } from "./LiveTrainingClubLogo";
import { requestLiveFullscreen } from "../../hooks/useLiveFullscreen";
import { formatTrainingSessionHash } from "../../utils/formatTrainingSessionLabel";

/** Club logo + "Session #N" title, shared by the coach and player live headers. */
export function LiveTrainingHeaderBrand({ session, user = null, isLandscape, subtitle = "" }) {
  const { t } = useTranslation();
  const sessionHash = formatTrainingSessionHash(session);

  return (
    <div className="lt-header__brand">
      <LiveTrainingClubLogo
        user={user}
        size={isLandscape ? "sm" : "md"}
        className="lt-header__club-logo"
      />
      <div className="lt-header__titles">
        <h1 className="lt-header__title">
          {sessionHash ? (
            <>
              {t("liveTrainingSessionTitle", { number: sessionHash }).replace(
                new RegExp(
                  `${sessionHash.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\s*$`
                ),
                ""
              )}
              <span className="lt-header__title-num">{sessionHash}</span>
            </>
          ) : (
            t("liveTrainingTitle")
          )}
        </h1>
        {subtitle ? <span className="lt-header__sub">{subtitle}</span> : null}
      </div>
    </div>
  );
}

export function LiveTrainingHeader({
  session,
  user = null,
  onHome,
  onRefresh,
  onSettings,
  refreshing = false,
  isLandscape,
}) {
  const { t } = useTranslation();

  return (
    <header className="lt-header">
      <LiveTrainingHeaderBrand
        session={session}
        user={user}
        isLandscape={isLandscape}
        subtitle={!isLandscape ? session?.gr_name : ""}
      />
      <div className="lt-header__actions">
        {onSettings ? (
          <button
            type="button"
            className="lt-header__icon-btn"
            onClick={onSettings}
            aria-label={t("liveTrainingSettings", "Live Training settings")}
            title={t("liveTrainingSettings", "Live Training settings")}
          >
            <SettingsIcon fontSize="small" />
          </button>
        ) : null}
        {onRefresh ? (
          <button
            type="button"
            className={`lt-header__icon-btn${
              refreshing ? " lt-header__icon-btn--spinning" : ""
            }`}
            onPointerDown={(e) => requestLiveFullscreen(e)}
            onClick={onRefresh}
            disabled={refreshing}
            aria-label={t("liveTrainingRefresh")}
            title={t("liveTrainingRefresh")}
          >
            <RefreshIcon fontSize="small" />
          </button>
        ) : null}
        <button
          type="button"
          className="lt-header__home-btn"
          onClick={onHome}
          aria-label={t("home") || "Home"}
          title={t("home") || "Home"}
        >
          <HomeIcon fontSize="small" />
          <span className="lt-header__home-label">{t("home") || "Home"}</span>
        </button>
      </div>
    </header>
  );
}

export default LiveTrainingHeader;
